<template lang="pug">
  div.upper-subpanel--inside
    div.col-6
      DrugInfo
    div.col-6
      ConfirmFlow(
        v-if="currentProgress === 'confirm'"
        :confirmProgress="confirmProgress"
        :actionProgress="actionProgress"
        v-on:confirmationFinish="getConfirmData"
      )
      Loader(
        v-if="currentProgress === 'finish'"
      )
</template>

<script>
import ConfirmFlow from './ConfirmFlow';
import DrugInfo from '../flowComp/DrugInfo';
import Loader from '../common/Loader';
import MultiFlowBase from '../ComponentBase/MultiFlowBase';

export default {
  name: 'multiFlow',
  extends: MultiFlowBase,
  components: {
    ConfirmFlow,
    DrugInfo,
    Loader,
  },
  methods: {
    getConfirmData() {
      console.log('get confirm data');
      this.nextProgress();
      console.log(this.currentProgress);
      if (this.nextEvent !== null) {
        this.$store.dispatch('toNextEvent');
        setTimeout(() => {
          this.resetProgress();
        }, 100);
      } else {
        this.$emit('setAllConfirmData');
      }
    },
  },
  created() {
    this.$store.dispatch('fromFirstEvent');
  },
  computed: {
    selectedEventId() {
      return this.$store.state.event.selectedEventId;
    },
  },
};
</script>




// WEBPACK FOOTER //
// MultiFlow.vue?09e4b269